import { useEffect, useState } from "react";

/**
 * Returns `value` after it has stayed stable for `delayMs`. Used by the
 * list screens (venues, properties, …) to avoid firing a search request
 * on every keystroke.
 *
 * The single shared home for the hook — `features/users`,
 * `features/subscriptions`, and the directory screens all import from
 * here (golden rule #3 — no cross-feature imports, no per-slice copies).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
